import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Typography,
  IconButton,
  Button,
  Alert
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import QRCode from 'react-qr-code';

/**
 * Dialog component for displaying and sharing the edit link
 */
const EditLinkDialog = ({ 
  open, 
  onClose, 
  editLink, 
  onCopy, 
  isUpdate 
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        {isUpdate ? 'Je persoonlijke edit link' : 'Bewaar je persoonlijke edit link'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {isUpdate 
            ? 'Met deze link kun je je gegevens later opnieuw bewerken. Bewaar deze link goed.'
            : 'Bewaar deze unieke link om je gegevens later te kunnen bewerken. Uit veiligheidsoverwegingen wordt deze link slechts één keer getoond.'}
        </DialogContentText>
        
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
          mb: 3,
          padding: 2,
          borderRadius: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.05)'
        }}>
          <Typography 
            variant="body2" 
            component="div" 
            sx={{ 
              flexGrow: 1,
              wordBreak: 'break-all'
            }}
          >
            {editLink}
          </Typography>
          <IconButton onClick={onCopy}>
            <ContentCopyIcon />
          </IconButton>
        </Box>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <QRCode 
            value={editLink}
            size={200}
          />
        </Box>
        
        {isUpdate && (
          <Alert severity="info" sx={{ mt: 2 }}>
            Je wordt automatisch doorgestuurd naar de registratiepagina...
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          color="primary"
        >
          Sluiten
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditLinkDialog; 